import { Icon } from 'prensa'
import React from 'react'

const IconFacebook = (props) => {
  return (
    <Icon xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M16.185 8.82h-2.85V6.95a.76.76 0 01.64-.86h2.16V3h-2.77a3.51 3.51 0 00-3.77 3.22 5 5 0 000 .55v2.06h-1.78v3.18h1.78v9h3.74v-9h2.52l.33-3.18v-.01z" />
    </Icon>
  )
}

export default IconFacebook

